export const HERO_IMAGE_URL =
  "/imagens-home/imagem-home.webp";